// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__mg3Ch","expireSoon":"styles_expireSoon__3Divw"};